var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"swiperContainer",staticClass:"swiper-container mb-4 pb-1"},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_c('span',{staticClass:"swiper-button-prev"}),_c('span',{staticClass:"swiper-button-next"})])}
var staticRenderFns = []

export { render, staticRenderFns }